export const MIN_PASSWORD_LENGTH = 8;
export const PASSWORD_SPECIAL_CHARS = "+-/*$&!%";
export const KC_IDP_HINT_PARAM = "kc_idp_hint";
